module.exports = __webpack_public_path__ + "static/media/blingV3_16.1281ec53.png";